import { FC } from 'react'
import { FlexProps, Flex, Text, TextProps } from '@chakra-ui/react'

type Props = FlexProps & {
  labelProps?: TextProps
  valueProps?: TextProps
  label?: string | JSX.Element
  value?: string | JSX.Element
}

const DescriptionItem: FC<Props> = ({ label, value, labelProps, valueProps, ...flexProps }) => {
  if (!label) return null

  const { flexDirection, flexDir, direction, dir } = flexProps
  const isRow = flexDirection == 'row' || flexDir == 'row' || direction == 'row' || dir == 'row'

  return (
    <Flex flexWrap="wrap" direction="column" gap={1} {...flexProps}>
      {typeof label === 'string' ? (
        <Text fontSize="sm" {...labelProps}>
          {label}
          {isRow && ':'}{' '}
        </Text>
      ) : (
        label
      )}
      {value ? (
        <>
          {typeof value === 'string' ? (
            <Text fontSize="sm" color="primary" {...valueProps}>
              {value}
            </Text>
          ) : (
            value
          )}
        </>
      ) : (
        <Text variant="noData" {...valueProps}>
          -
        </Text>
      )}
    </Flex>
  )
}

export default DescriptionItem
